angular.module("app").directive("export", [
    'exportService',
    function (exportService) {
        return {
            restrict: "A",
            scope: {
                export: "@"
            },
            link: function ($scope, element, attributes) {
                element.bind('click', function(event) {
                    var self = angular.element(this),
                        exportAction = $scope.export || null,
                        exportFilters = $scope.$parent[attributes.exportFilters] || {};
                    var request;
                    if (attributes.exportProvider) {
                        request = {};
                        if (exportFilters.provider) {
                            request.provider = exportFilters.provider;
                        } else {
                            request.game_id = exportFilters.gameId;
                        }

                    } else {
                        request = exportFilters;
                    }
                    if (exportAction && typeof exportService[exportAction] === 'function' && ! self.hasClass('disabled')) {
                        exportService[exportAction](request);
                    }
                });
            }
        }
    }
]);
